import axios from 'axios';

const API_URL = process.env.VUE_APP_API_URL;

//axios.defaults.baseURL = API_URL;

function onError(err) {
    if (err.response) {
        console.error('onError()->Error response:', err.response.data);
        return {
            Success: false,
            Error: err.response.data.Error,
            Message: 'Error response: ' + err.response.data.Message
        }
    } else if (err.request) {
        console.error('onError()->No response received:', err.response.data);
        return {
            Success: false,
            Error: err.request,
            Message: 'No response received: ' + err.request
        }
    } else {
        console.error('onError()->Error setting up request:', err.response.data);
        return {
            Success: false,
            Error: err.message,
            Message: 'Error setting up request: ' + err.message
        }
    }
}

export const qrCodeService = {
    async getQRCodes() {
        try {
            const response = await axios.get(API_URL + "qrcode/getqrcodes/");
            return response.data; // Zwraca obiekt z API
        } catch (err) {
            return onError(err);
        }
    },
    async getQRCode(id) {
        if (parseInt(id) > 0) {
            try {
                const response = await axios.get(API_URL + "qrcode/getqrcode/" + id);
                return response.data; // Zwraca obiekt z API
            } catch (err) {
                return onError(err);
            }

        }
    },
    async createQRCode(qrCode) {
        try {
            const result = await axios.post(API_URL + "qrcode/createqrcode", qrCode, { responseType: 'blob' });
            return result.data;
        } catch (err) {
            return onError(err);
        }

    },
    async deleteQRCode(qrCode) {
        try {
            const result = await axios.post(API_URL + "qrcode/deleteqrcode", qrCode);
            return result.data;
        } catch (err) {
            return onError(err);
        }
    }
}